var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgControl = function SvgControl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    x: 3,
    y: 3,
    fill: "#E2FFEA",
    rx: 27
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    x: 3,
    y: 3,
    stroke: "#F4FFF7",
    strokeWidth: 6,
    rx: 27
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#51C394",
    clipPath: "url(#control_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.375 23.875h-22.75A2.625 2.625 0 0 1 16 21.25v-2.625A2.625 2.625 0 0 1 18.625 16h22.75A2.625 2.625 0 0 1 44 18.625v2.625a2.625 2.625 0 0 1-2.625 2.625m-22.75-6.125a.875.875 0 0 0-.875.875v2.625a.875.875 0 0 0 .875.875h22.75a.875.875 0 0 0 .875-.875v-2.625a.875.875 0 0 0-.875-.875zM26.5 33.5h-7.875A2.625 2.625 0 0 1 16 30.875V28.25a2.625 2.625 0 0 1 2.625-2.625H26.5a2.625 2.625 0 0 1 2.625 2.625v2.625A2.625 2.625 0 0 1 26.5 33.5m-7.875-6.125a.875.875 0 0 0-.875.875v2.625a.875.875 0 0 0 .875.875H26.5a.875.875 0 0 0 .875-.875V28.25a.875.875 0 0 0-.875-.875zM26.5 43.125h-7.875A2.625 2.625 0 0 1 16 40.5v-2.625a2.625 2.625 0 0 1 2.625-2.625H26.5a2.625 2.625 0 0 1 2.625 2.625V40.5a2.625 2.625 0 0 1-2.625 2.625M18.625 37a.875.875 0 0 0-.875.875V40.5a.875.875 0 0 0 .875.875H26.5a.875.875 0 0 0 .875-.875v-2.625A.875.875 0 0 0 26.5 37zM41.375 43.125H33.5a2.625 2.625 0 0 1-2.625-2.625V28.25a2.625 2.625 0 0 1 2.625-2.625h7.875A2.625 2.625 0 0 1 44 28.25V40.5a2.625 2.625 0 0 1-2.625 2.625M33.5 27.375a.875.875 0 0 0-.875.875V40.5a.875.875 0 0 0 .875.875h7.875a.875.875 0 0 0 .875-.875V28.25a.875.875 0 0 0-.875-.875z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "control_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 16h28v28H16z"
  })))));
};
export default SvgControl;